module.exports = __webpack_public_path__ + "static/media/logo.cc3fff7e.svg";